var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_Symbol.js
// module id = 278
// module chunks = 168707334958949